import React from "react";
import { Button, Spinner } from "reactstrap";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { createMarkup } from "@/shared/helpers";

const TemplateButton = ({
  className,
  onClick,
  text,
  type,
  disabled,
  link,
  color,
  spinner
}) => {
  let navigate = useNavigate();
  const routeChange = () => {
    navigate(link);
  };
  className =
    "template-button border-0" + (className !== "" ? " " + className : "");
  onClick = link ? routeChange : onClick;
  const buttonStyle = {
    display: 'flex',
    gap: '5px',
    alignItems: 'center',
  };

  return (
    <>
      <Button
        color={color?color:null}
        className={className}
        onClick={onClick}
        style={buttonStyle}
        type={type ? type : "submit"}
        disabled={disabled}
      >
        {spinner && <Spinner
          as="span"
          animation="grow"
          size="sm"
          role="status"
          aria-hidden="true"
        />}
        <div dangerouslySetInnerHTML={createMarkup(text)}/>
      </Button>
    </>
  );
};

TemplateButton.propTypes = {
  text: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  color: PropTypes.string,
  onClick: PropTypes.func,
};

TemplateButton.defaultProps = {
  text: "Click me!",
  disabled: false,
  className: "",
  color: "primary",
  onClick: Object,
};

export default TemplateButton;
